import z from 'zod';
import { DISCO_CODE } from '../discoData';
import { walletKycDirectorSchema } from '../../schemas/wallet-kyc-schema';

// THIS WAS MOVED HERE MAINLY TO REDUCE LINE OF CODE IN directorDialog.tsx file
export const Basic_Director_Info = [
  {
    name: 'first_name',
    label: 'first name*',
    placeholder: 'E.g. Joseph',
  },
  {
    name: 'last_name',
    label: 'last name*',
    placeholder: 'E.g. Akilo',
  },
  {
    name: 'middle_name',
    label: 'middle name',
    placeholder: 'E.g. Timi',
  },
  {
    name: 'email',
    label: 'email*',
    placeholder: 'E.g. Josephakilo@email.com',
  },
  {
    name: 'address',
    label: 'address*',
    placeholder: 'E.g. 12 Adeola Odeku Street, Victoria Island, Lagos',
  },
];

export const Director_Roles_Options = [
  {
    label: 'owner',
    value: 'owner',
    disabled: false,
  },
  {
    label: 'director',
    value: 'director',
    disabled: false,
  },
  {
    label: 'manager',
    value: 'manager',
    disabled: false,
  },
  {
    label: 'secretary',
    value: 'secretary',
    disabled: false,
  },
];

export const Disco_Code_Options = DISCO_CODE.map((item) => ({
  label: item,
  value: item,
}));

export const Director_Security_info = [
  {
    name: 'bvn',
    label: 'bank verification number (BVN)*',
    placeholder: 'E.g. 1234567890...',
    max: 11,
  },
  {
    name: 'nin',
    label: 'national identification number (NIN)*',
    placeholder: 'E.g. 1234567890...',
    max: 11,
  },
  {
    name: 'meter_number',
    label: 'meter number*',
    placeholder: 'E.g. 1234567890...',
  },
];

// HELPERS
type DirectorInformationShape = z.infer<typeof walletKycDirectorSchema>;

export const generateDirectorFormTriggerArray = (
  idx: number
): Array<`directors.${number}.${keyof DirectorInformationShape}`> => {
  return [
    `directors.${idx}.first_name`,
    `directors.${idx}.last_name`,
    `directors.${idx}.middle_name`,
    `directors.${idx}.email`,
    `directors.${idx}.phone_number`,
    `directors.${idx}.role`,
    `directors.${idx}.percentage_ownership`,
    `directors.${idx}.nin`,
    `directors.${idx}.bvn`,
    `directors.${idx}.date_of_birth`,
    `directors.${idx}.meter_number`,
    `directors.${idx}.disco_code`,
    `directors.${idx}.address`,
  ];
};

export const Director_Form_Initial_Field_Values: Partial<DirectorInformationShape> =
  {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    role: 'director' as const,
    address: '',
    disco_code: '',
    percentage_ownership: 0,
  };
